import xd from "../../images/particles/adobexd-logo.svg";
import aftereffects from "../../images/particles/aftereffects-logo.svg";
import figma from "../../images/particles/figma-logo.svg";
import illustrator from "../../images/particles/illustrator-logo.svg";
import invision from "../../images/particles/invision -logo.svg";
import photoshop from "../../images/particles/photoshop-logo.svg";
import react from "../../images/particles/react-logo.svg";
import php from "../../images/particles/php-logo.svg";
import wordpress from "../../images/particles/wordpress-logo.svg";
import nodejs from "../../images/particles/nodejs-logo.svg";
import javascript from "../../images/particles/javascript-logo.svg";
import java from "../../images/particles/java-logo.svg";
import html from "../../images/particles/html5-logo.svg";
import android from "../../images/particles/android -logo.svg";
import angular from "../../images/particles/angular-logo.svg";
import vue from "../../images/particles/vue-logo.svg";
import github from "../../images/particles/github-logo.svg";
import bootstrap from "../../images/particles/bootstrap-logo.svg";
import css from "../../images/particles/css-logo.svg";
import python from "../../images/particles/python-logo.svg";
import aws from "../../images/particles/aws-logo.svg";
import sass from "../../images/particles/sass-logo.svg";
import mysql from "../../images/particles/mysql-logo.svg";
import laravel from "../../images/particles/laravel -logo.svg";
import materialize from "../../images/particles/materialize-logo.svg";
import tailwind from "../../images/tailwind-logo.svg";
import firebase from "../../images/firebase-logo.svg";

export const heroParticlesConfig = {
  particles: {
    line_linked: {
      enable: false,
    },
    move: {
      out_mode: "out",
      direction: "top",
    },
    shape: {
      type: "images",
      images: [
        { src: xd, height: 20, width: 20 },
        { src: aftereffects, height: 20, width: 20 },
        { src: figma, height: 30, width: 20 },
        { src: illustrator, height: 20, width: 20 },
        { src: invision, height: 20, width: 20 },
        { src: photoshop, height: 20, width: 20 },
        { src: react, height: 20, width: 20 },
        { src: react, height: 20, width: 20 },
        { src: php, height: 20, width: 30 },
        { src: wordpress, height: 20, width: 20 },
        { src: nodejs, height: 20, width: 20 },
        { src: javascript, height: 20, width: 20 },
        { src: java, height: 20, width: 20 },
        { src: html, height: 20, width: 20 },
        { src: android, height: 25, width: 20 },
        { src: angular, height: 20, width: 20 },
        { src: vue, height: 20, width: 20 },
        { src: github, height: 20, width: 20 },
        { src: bootstrap, height: 20, width: 20 },
        { src: css, height: 20, width: 20 },
        { src: python, height: 20, width: 20 },
        { src: aws, height: 30, width: 30 },
        { src: sass, height: 20, width: 20 },
        { src: mysql, height: 20, width: 20 },
        { src: laravel, height: 20, width: 20 },
        { src: materialize, height: 20, width: 30 },
        { src: tailwind, height: 20, width: 30 },
        { src: firebase, height: 30, width: 20 },
      ],
    },
    color: {
      value: "#00ff00",
    },
    opacity: {
      value: 0.6,
    },
    size: {
      value: 25,
      random: false,
      anim: {
        enable: true,
        speed: 4,
        size_min: 10,
        sync: false,
      },
    },
  },
  interactivity: {
    events: {
      onhover: {
        enable: true,
        mode: "bubble",
      },
    },
  },
  retina_detect: false,
};
